import { needsConnorsApplyConfirm } from "./connorsApplyUtils";
import { requestConnorsApplyConfirm } from "./connorsApplyConfirmRegistry";

export function runWithConnorsApplyConfirm(job, onContinue, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (!needsConnorsApplyConfirm(job)) {
    onContinue();
    return;
  }

  requestConnorsApplyConfirm(onContinue);
}
